export function QuoteCard() {
  return (
    <div className="bento-no-min row-span-3 flex flex-col h-full">
      <h3 className="font-heading text-md [@media(min-width:414px)]:text-lg text-foreground mb-4">
        Business-First Tech Leader
      </h3>
      <p className="font-body text-sm text-muted-foreground font-light leading-relaxed">
        "From ML research to Co-Founder & CTO, I have learned that brilliant tech means nothing without business impact. Every system I build starts with one question: How will this move the business forward?"
      </p>
    </div>
  );
}